module.exports = __webpack_public_path__ + "static/media/message.2ac13eb1.svg";